var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mute-display-button"},[_c('a-icon',{attrs:{"type":"notification"}}),_vm._v(" Muted ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }